import React, { useState } from 'react'
import "./Main_wallet_Withdrowal.css"
import Common_recharge_page_banner from '../../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner'
import Withdraw_tab_contant from '../../../recharge_wallate/withdraw_tab_contant/Withdraw_tab_contant'
import Withdraw_History_list_contant from '../../../recharge_wallate/withdraw_tab_contant/withdraw_History_list_contant/Withdraw_History_list_contant';
import { Button } from 'react-bootstrap';

function Main_wallet_Withdrowal() {
    const [showHistory, setShowHistory] = useState(false);

    const breadcrumbData = [
        { label: "wallet", path: "/main-wallet", active: false },
        { label: "WITHDRAW", active: true }
    ];
    return (
        <>
            <section className='Main_wallet_Withdrowal upgraded_menu_sections wallet_inner_banner_section'>
                <div className="container">
                    <Common_recharge_page_banner title="WITHDRAW" className="Upgraded_menu_banner" breadcrumbItems={breadcrumbData} />
                    <div className="row justify-content-center">
                        <div className="col-lg-7 col-md-10">
                            <div className="profile_tabs_and_content">
                                <div className="section_holder">
                                    <Withdraw_tab_contant />
                                    {/* ===== HISTORY LIST HOLDER ===== */}

                                </div>
                            </div>


                            <div className="history_list_holder">
                                <div className="wallet-action">
                                    <Button
                                        className="Show_history"
                                        onClick={() => setShowHistory(!showHistory)}
                                    >
                                        {showHistory ? "Hide History" : "Show History"}
                                    </Button>

                                    {showHistory && (
                                        <Withdraw_History_list_contant />

                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Main_wallet_Withdrowal